import React from 'react';

const Opensource = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Open source work</h1>
      <p>Learn more about our company, our mission, and our team.</p>
      <p>Share your company's story, values, and what makes you unique in your industry.</p>
      <h3>Our Mission</h3>
      <p>Add your company's mission statement here.</p>
      <h3>Our Team</h3>
      <p>Introduce your team members and their expertise.</p>
    </div>
  );
};

export default Opensource;
